/**
 * @author Yakov.Gushchin
 * @version 1.0.0
 */
import { IRangeDatePickerDayCell } from '../CalendarCell';
import * as dates from './dates';

export default function cx(props: IRangeDatePickerDayCell) {
    const { day, calendar, startDate, side, endDate, maxDate, minDate } = props;
    const weekend = dates.isWeekend(day);
    const inRange = dates.isBetweenExclusive(startDate, endDate, day);
    const isEndDate =
        endDate && day.format('YYYY-MM-DD') === endDate.format('YYYY-MM-DD');
    const isStartDate =
        startDate && day.format('YYYY-MM-DD') === startDate.format('YYYY-MM-DD');
    const active = isStartDate || isEndDate;
    const off =
        (calendar.month() !== day.month() ||
            dates.isNotBetween(minDate, maxDate, day)) && calendar.month() < day.month();
    const invisible = (calendar.month() !== day.month() ||
        dates.isNotBetween(minDate, maxDate, day)) && calendar.month() > day.month();
    const disabled = dates.isNotBetween(minDate, maxDate, day) || (side === 'right' && day < startDate);
    const available = !disabled;
    return `${weekend ? 'weekend' : ''} ${inRange ? 'in-range' : ''} ${isEndDate ? 'end-date' : ''} ` +
        `${isStartDate ? 'start-date' : ''} ${active ? 'active' : ''} ${off ? 'off' : ''} ` +
        `${disabled ? 'disabled' : ''} ${available ? 'available' : ''} ${invisible ? 'invisible' : ''}`;
}
